import { render } from "./AddNewClient.vue?vue&type=template&id=8ae753b0"
import script from "./AddNewClient.vue?vue&type=script&lang=js"
export * from "./AddNewClient.vue?vue&type=script&lang=js"

import exportComponent from "/home/clients/74415e597e89acaa30448f5e983fc289/sites/poses.renosolu.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__